function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import InlineSvg from './InlineSvg';
import ProfileMenuLinks from './ProfileMenuLinks';
import MobileContextMenu from './MobileContextMenu';

var ProfileMenu = function (_React$Component) {
  _inherits(ProfileMenu, _React$Component);

  function ProfileMenu(props) {
    _classCallCheck(this, ProfileMenu);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onProfileClick = function () {
      _this.setState({
        profileMouseOut: false,
        profileMenuOpen: true
      });
    };

    _this.onProfileMouseOver = function () {
      _this.setState({
        profileMouseOut: false
      });
    };

    _this.onProfileMouseLeave = function () {
      _this.setState({
        profileMouseOut: true
      });
      setTimeout(function () {
        if (this.state.profileMouseOut === true) {
          this.setState({
            profileMenuOpen: false
          });
        }
      }.bind(_this), 300);
    };

    _this.state = {
      profileMenuOpen: false,
      profileMouseOut: true
    };
    return _this;
  }

  ProfileMenu.prototype.render = function render() {
    var _props = this.props,
        authUserName = _props.authUserName,
        onlineStoreAccountURL = _props.onlineStoreAccountURL,
        organisations = _props.organisations,
        teams = _props.teams,
        currentOrganisation = _props.currentOrganisation,
        organisationChange = _props.organisationChange,
        currentTeam = _props.currentTeam,
        teamChange = _props.teamChange;


    return React.createElement(
      'div',
      { className: 'profile' },
      React.createElement(
        'div',
        {
          className: 'profile__icon',
          onMouseOver: this.onProfileMouseOver,
          onFocus: this.onProfileMouseOver,
          onClick: this.onProfileClick,
          onMouseOut: this.onProfileMouseLeave,
          onBlur: this.onProfileMouseLeave
        },
        organisations && organisations.length > 1 || teams && teams.length > 1 ? React.createElement(
          'span',
          { className: 'profile__icon-text' },
          React.createElement(
            'strong',
            null,
            authUserName
          )
        ) : null,
        React.createElement(InlineSvg, { name: 'userIcon', colour: 'grey' }),
        React.createElement(InlineSvg, {
          name: 'dropDownArrow',
          className: 'dropdown-arrow ' + (this.state.profileMenuOpen ? 'dropdown-arrow--open' : '')
        })
      ),
      React.createElement(
        'div',
        {
          className: 'profile__menu ' + (this.state.profileMenuOpen ? 'profile__menu--open' : '') + ' ' + (organisations && organisations.length === 1 || teams && teams.length === 1 ? 'profile__menu--org-team' : ''),
          onMouseOver: this.onProfileMouseOver,
          onFocus: this.onProfileMouseOver,
          onMouseOut: this.onProfileMouseLeave,
          onBlur: this.onProfileMouseLeave
        },
        organisations && organisations.length <= 1 && teams && teams.length <= 1 ? React.createElement(
          'div',
          { className: 'profile-menu__name' },
          authUserName
        ) : null,
        organisations && organisations.length === 1 ? React.createElement(MobileContextMenu, {
          contextType: 'Organisation',
          items: organisations,
          currentItem: currentOrganisation,
          handleItemChange: organisationChange
        }) : null,
        teams && teams.length === 1 ? React.createElement(MobileContextMenu, {
          contextType: 'Team',
          items: teams,
          currentItem: currentTeam,
          handleItemChange: teamChange
        }) : null,
        React.createElement(ProfileMenuLinks, { onlineStoreAccountURL: onlineStoreAccountURL })
      )
    );
  };

  return ProfileMenu;
}(React.Component);

export default ProfileMenu;